const BrowserHistoryCtl = {
    addCurrentPage() {
        let path = window.location.href;
        this.set({}, '', path);
    },

    set(state, title, url) {
        history.pushState(state, title, url);
    },
};

export { BrowserHistoryCtl };
